import { ccc } from "."

export const Padding = ccc({ padding: 20 })
